'use client';
import Image from 'next/image';
import bg from './bg.png';
import { usePathname } from 'next/navigation';
import clsx from 'clsx';

function DynamicBg() {
  const pathname = usePathname();

  const getGradientColor = () => {
    if (pathname.includes('/scans/maven')) return 'from-[#231992]';
    if (pathname.includes('/scans/sbt')) return 'from-[#a31919]';
    return 'from-gradle-green';
  };

  return (
    <div className="absolute inset-0 top-36 z-0 hidden lg:block">
      <Image src={bg} alt="grid design" fill className="object-cover opacity-50" priority />
      <div
        className={clsx(
          'absolute -right-48 bottom-72 z-10 h-[50rem] w-96 bg-gradient-radial to-transparent to-70% opacity-40',
          getGradientColor(),
        )}
      ></div>
      <div
        className={clsx(
          'absolute -left-48 bottom-12 z-10 h-[50rem] w-96 bg-gradient-radial to-transparent to-70% opacity-40',
          getGradientColor(),
        )}
      ></div>
    </div>
  );
}
export default DynamicBg;
